import React from 'react';
import MultiSelect from './MultiSelect';
import { withStyles,} from '@material-ui/core';
class PhysycianFilter extends React.Component{
    constructor(props) {
        super(props);
        this.state = {
            multiValue: [],
            count:[],
            providersForFilter:[], showMultiselect:false
            };
            }
handlePhyscianFilterChange = (selectedValue) =>{
        this.setState({multiValue:selectedValue});
        this.props.filterPhysicianPatient(selectedValue,"status");
        };
filterdata=(filtervalue)=>{
if(this.state.providersForFilter.length===0){
    const filterPhyscianresult = [];
            let isCurrentUser = false;
            let currentUser;
            let uniqueArray = [];
            let uniqueArrayupdate=[];
            if (filtervalue) {
                filtervalue.map(item => {
                    uniqueArrayupdate.push({ id: item.id, name: item.createdBy });
                    uniqueArrayupdate.push({ id: item.id, name: item.modifiedBy });
                });
                uniqueArray = [...new Map(uniqueArrayupdate.map(item => [item.name, item])).values()];
                uniqueArray.map((obj) => {
                    if (obj.name === "") {
                        return filterPhyscianresult.push({
                            value: obj.id,
                            label: "Unavailable"
                        });
                    } else {
                        return filterPhyscianresult.push({
                            value: obj.id,
                            label: obj.name
                        });
                    }
                });
            }
            this.setState({providersForFilter:filterPhyscianresult, showMultiselect:true});
            if(isCurrentUser){
                this.props.filterPhysicianPatient([currentUser],"status");
            } else{
                this.props.filterPhysicianPatient(currentUser,"status");
            }
}
};
componentDidMount(){
        this.filterdata(this.props.physicianList);
        }
componentDidUpdate(prevProps){
this.filterdata(this.props.physicianList);
           if(prevProps.reqAttentionFilter !== this.props.reqAttentionFilter){
             this.handlePhyscianFilterChange([]);
            }
        }
    render(){
        return(
            <>{this.state.showMultiselect?
                <MultiSelect
                options={this.state.providersForFilter}
                name={"Created By"}
                isMulti
                checkBoxStyled
                onChange={this.handlePhyscianFilterChange}
                value={this.state.multiValue}
                isSearchable = {false}
                isClearable = {false}
                placeholder = {this.state.multiValue&&this.state.multiValue.length>0?"Created By/ Update ":"Created By/ Update : All"}
                textFieldProps={{
                    variant:"outlined",
                    label:''
                }}
                >
                </MultiSelect>:""}
            </>
        );
    }
}

export default (withStyles()(PhysycianFilter));